module.exports = "<div class=\"container\" [ngClass]=\"config.level\">\n    <p *ngIf=\"config.title\">\n      {{config.title}}\n    </p>\n    <p *ngIf=\"config.message\" [innerHTML]=\"config.message | translateHandlebars : config\">\n    </p>\n    <div *ngFor=\"let action of config.actions\">\n      <button [ngClass]=\"action.style\" [routerLink]=\"action.link\">{{action.title | translate}}</button>\n    </div>\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/common/communication-box/communication-box.component.html
// module id = 928
// module chunks = 0